import { render, staticRenderFns } from "./sim.vue?vue&type=template&id=0d71d36d&scoped=true"
import script from "./sim.vue?vue&type=script&lang=js"
export * from "./sim.vue?vue&type=script&lang=js"
import style0 from "./sim.vue?vue&type=style&index=0&id=0d71d36d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d71d36d",
  null
  
)

export default component.exports